import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

import { DpDeliveryCenter } from '@app/core/types/backend/dp-delivery-center.interface';

@Injectable({ providedIn: 'root' })
export class DpStockInfoService {
  readonly #http = inject(HttpClient);
  readonly #occ = inject(OccEndpointsService);

  fetchStockData(productCode: string): Observable<DpDeliveryCenter[]> {
    const url = this.#occ.buildUrl(`/products/${productCode}/delivery-centers`);
    return this.#http.get<DpDeliveryCenter[]>(url);
  }
}
